import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderSupportRequestsStatusesAdapter = getAdapter({ idFieldName: 'value' });

const orderSupportRequestsStatusesSlice = createSlice({
  name: 'orderSupportRequestsStatuses',
  initialState: orderSupportRequestsStatusesAdapter.getInitialState(),
  reducers: {
    setOrderSupportRequestsStatuses: (state, { payload: { orderSupportRequestsStatuses } }) => {
      orderSupportRequestsStatusesAdapter.setAll(state, orderSupportRequestsStatuses);
    },
  },
});

const selectors = orderSupportRequestsStatusesAdapter.getSelectors(({ orderSupportRequestsStatuses }) => orderSupportRequestsStatuses);

export const getOrderSupportRequestsStatuses = (state) => selectors.selectAll(state);

export const {
  setOrderSupportRequestsStatuses,
} = orderSupportRequestsStatusesSlice.actions;

export default orderSupportRequestsStatusesSlice.reducer;